import { DevicesSideMenuWebComponent } from './component/DevicesSideMenuWebComponent';

export { DevicesSideMenuWebComponent };
